import React from 'react'
import { Link } from 'react-router-dom'
import './ProviderLanding.css'

import LogoLoopSection from '../home/sections/LogoLoopSection'
import JoinProvider from '../home/sections/JoinProvider'
import Footer from '../../components/Footer'

export default function ProviderLanding() {
  return (
    <div className="provider-landing">
      <section className="provider-hero" aria-labelledby="provider-hero-title">
        <span className="provider-hero__eyebrow">Alianza Flotte</span>
        <h1 id="provider-hero-title" className="provider-hero__title">
          Unete como proveedor
        </h1>
        <p className="provider-hero__subtitle">
          Presenta tu oferta, conecta con empresas calificadas y gestiona toda tu operacion desde un panel unico.
        </p>
        <div className="provider-hero__actions">
          <Link className="provider-hero__cta" to="/register/provider">
            Comenzar registro
          </Link>
          <Link className="provider-hero__link" to="/marketplace">
            Ver demandas activas
          </Link>
        </div>
      </section>

      <LogoLoopSection />

      <JoinProvider />

      <Footer />
    </div>
  )
}
